import { render, staticRenderFns } from "./CustComplaint.vue?vue&type=template&id=71dd96ba&scoped=true"
import script from "./CustComplaint.vue?vue&type=script&lang=js"
export * from "./CustComplaint.vue?vue&type=script&lang=js"
import style0 from "./CustComplaint.vue?vue&type=style&index=0&id=71dd96ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd96ba",
  null
  
)

export default component.exports